import { useStoreAuth } from '@/context/StoreAuthContext';

interface UserTypeResult {
  isSuperAdmin: boolean;
  isRegularUser: boolean;
  isLoading: boolean;
}

/**
 * No-op mantido por compatibilidade. O tipo do usuário agora é derivado
 * diretamente do StoreAuthContext (que já chama profiles + is_platform_admin
 * uma única vez), eliminando RPCs duplicadas durante o login.
 */
export const clearUserTypeCache = (): void => {
  // intencional: nada a limpar — estado vive no StoreAuthContext
};

export const useUserType = (): UserTypeResult => {
  const { user, isLoading } = useStoreAuth();

  if (isLoading) {
    return { isSuperAdmin: false, isRegularUser: false, isLoading: true };
  }

  if (!user) {
    return { isSuperAdmin: false, isRegularUser: false, isLoading: false };
  }

  const isSuperAdmin = !!user.isPlatformAdmin;
  return {
    isSuperAdmin,
    isRegularUser: !isSuperAdmin,
    isLoading: false,
  };
};
